import {
  CATEGORIES_STATUS,
  GET_MEMBER_CATEGORIES,
  GET_MEMBER_SUB_CATEGORIES,
  GET_MEMBER_SUB_CATEGORIES_DETAILS,
  SUB_CATEGORIES_STATUS,
} from "../constants/memberCategoryConstants";

const init = {
  categories: [],
  subCategories: [],
  subCategoryDetail: null,
  categoryStatus: false,
  subCategoryStatus: false,
};

const memberCategoryReducer = (state = init, action: any) => {
  switch (action.type) {
    case GET_MEMBER_SUB_CATEGORIES: {
      return {
        ...state,
        subCategories: action.payload.data,
        listStatus: true,
      };
    }
    case GET_MEMBER_CATEGORIES: {
      return {
        ...state,
        categories: action.payload.data,
        categoryStatus: true,
        subCategoryStatus: true,
      };
    }
    case GET_MEMBER_SUB_CATEGORIES_DETAILS: {
      return {
        ...state,
        subCategoryDetail: action.payload.data,
        detailStatus: true,
      };
    }
    case CATEGORIES_STATUS: {
      return {
        ...state,
        categoryStatus: false,
      };
    }
    case SUB_CATEGORIES_STATUS: {
      return {
        ...state,
        subCategoryStatus: false,
      };
    }
    default:
      return state;
  }
};
export default memberCategoryReducer;
